const base_url = process.env.REACT_APP_BASE_URL

const api_url = {
  base_url,
  url: base_url.concat("/") + process.env.REACT_APP_OTHER_MODULES_URL,
  loginUrl: base_url.concat("/") + process.env.REACT_APP_LOGIN_URL,
  thinkGasHes: base_url.concat("/") + process.env.REACT_APP_THINK_GAS_HES
}

export default api_url
